import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { Store } from '@ngrx/store';
import { getUnloadTimes } from '../../../rms-specification/selectors/single-catalogs';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { Features } from '@ordersnproducts/features';
import { filter, take } from 'rxjs/operators';
import { SpecFieldNames } from '../../constants/specification-field-names.enum';
import { UNLOAD_TYPE_MIN_TIMES_MAP } from '../../constants/unload-type-min-times-map';
import { ChangeUnloadTimeAction } from '../../../rms-specification/actions/single-catalogs.actions';
import { ImUnloadTime } from '@cemex-core/cmx-api';

@Injectable()
export class SetDefaultUnloadTimeCommand implements OnFieldChanged {
  constructor(
    private store: Store<OrderBuilderState>,
    private featureToggleService: FeatureToggleService,
  ) {}

  onFieldChanged(
    value: any,
    formGroup: FormGroup,
    form: ConfigurableFormComponent | null,
    config?: FieldConfig,
    prev?: any,
  ): void {
    if (!this.featureToggleService.isFeatureEnabled(Features.UNLOAD_TYPE_AND_APPLICATION_CATALOGUES_HOMOLOGATION)) {
      return;
    }
    if (!value) {
      return;
    }

    this.store
      .select(getUnloadTimes)
      .pipe(
        filter((data) => data.length > 0),
        take(1),
      )
      .subscribe((unloadTimes: ImUnloadTime[]) => {
        const minUnloadTime = UNLOAD_TYPE_MIN_TIMES_MAP[value];
        const defaultUnloadTime = unloadTimes.find((time) => time.unloadTimeMinutes === minUnloadTime);
        if (defaultUnloadTime) {
          formGroup.get(SpecFieldNames.DISCHARGE_TIME).setValue(defaultUnloadTime.unloadTimeCode);
          this.store.dispatch(new ChangeUnloadTimeAction(defaultUnloadTime.unloadTimeMinutes));
        }
      });
  }
}
